import React from 'react';
import {clearAuthStorage, hasAnyPermission, hasPermission} from '@/utils/auth';
import {permissionForPath} from '@/config/routePermissions';
import {getDefaultLandingPath} from '@/utils/defaultLandingPath';
import {Navigate, useLocation} from 'react-router-dom';
import {Result} from 'antd';

function parseJwt(token: string) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

function isTokenExpired(token: string) {
  const payload = parseJwt(token);
  console.log('JWT payload:', payload); // 调试用
  if (!payload || !payload.exp) return true;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp < now;
}

function allows(required: string | string[] | undefined) {
  if (!required) {
    return true;
  }
  return Array.isArray(required) ? hasAnyPermission(required) : hasPermission(required);
}

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token || isTokenExpired(token)) {
    clearAuthStorage();
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  const required = permissionForPath(location.pathname);
  if (required && !allows(required)) {
    const landing = getDefaultLandingPath();
    const landingPermission = permissionForPath(landing);
    if (landing !== location.pathname && allows(landingPermission)) {
      return <Navigate to={landing} replace />;
    }
    return <Result status="403" title="无权访问该页面" />;
  }

  return <>{children}</>;
};

export default AuthGuard;
